let containerLoaderTemplate: HTMLTemplateElement | null = null;
let buttonLoaderTemplate: HTMLTemplateElement | null = null;


export function initLoaderService() {
  containerLoaderTemplate = document.getElementById(
    "template_containerLoader",
  ) as HTMLTemplateElement | null;
  buttonLoaderTemplate = document.getElementById(
    "template_buttonLoader",
  ) as HTMLTemplateElement | null;


  if (!containerLoaderTemplate)
    console.warn("LoaderService: Container loader template not found in DOM.");
  if (!buttonLoaderTemplate)
    console.warn("LoaderService: Button loader template not found in DOM.");
}

export function showContainerLoader(
  container: HTMLElement,
  caption?: string,
): void {
  if (!containerLoaderTemplate) {
    console.warn("Container loader skipped. Service not initialized.");
    return;
  }

  hideContainerLoader(container);

  const fragment = containerLoaderTemplate.content.cloneNode(
    true,
  ) as DocumentFragment;

  const captionElement = fragment.querySelector(
    "span[data-loader-caption]",
  ) as HTMLSpanElement | null;

  if (captionElement) {
    captionElement.textContent = caption ?? "Loading…";
  }

  container.append(fragment);
}


export function hideContainerLoader(container: HTMLElement): void {
  container.querySelectorAll("div.scw-loader").forEach((loader) => {
    loader.remove();
  });
}

export function setButtonLoading(
  button: HTMLButtonElement | null | undefined,
  isLoading: boolean,
): void {
  if (!button) return;

  const existing = button.querySelector("span.scw-btn-loader");

  if (!isLoading) {
    existing?.remove();
    return;
  }

  if (existing || !buttonLoaderTemplate) return;

  const fragment = buttonLoaderTemplate.content.cloneNode(
    true,
  ) as DocumentFragment;

  button.prepend(fragment);
}
